import { gql, useApolloClient, useQuery } from '@apollo/client';
import {
  GetUsersQuery,
  GetUsersQueryVariables,
} from '../../__generated__/queries-auth';
import { useFetch } from '../../utils/useFetch';

export const GET_USERS = gql`
  query GetUsers(
    $first: UnsignedInt!
    $skip: UnsignedInt
    $where: UserFilterInput
    $orderBy: [UserOrderingInput!]
  ) {
    users(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
      id
      name
      createdAt
      email
      roles
      googleId
    }
  }
`;

export const useGetUsers = (
  variables: GetUsersQueryVariables,
  skip?: boolean,
) =>
  useQuery<GetUsersQuery, GetUsersQueryVariables>(GET_USERS, {
    variables,
    skip,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });

export const useGetUsersPromise = () =>
  useFetch<GetUsersQuery, GetUsersQueryVariables>(GET_USERS);

export const useUsersGetter = () => {
  const apolloClient = useApolloClient();

  return async (name_contains: string) => {
    const { data, errors } = await apolloClient.query<
      GetUsersQuery,
      GetUsersQueryVariables
    >({
      query: GET_USERS,
      variables: { first: 100, where: { name_contains } },
    });

    if (errors?.length) {
      throw errors[0];
    }
    return data?.users;
  };
};
